<template>
    <h1 class="heading-2 ocupation-title" title="Categoria Professional">
        Ocupação
    </h1>
    <h6 class="color-text-body ocupation-subtitle">
        Qual das seguintes opções se enquadra melhor nos teus&nbsp;serviços?
    </h6>
    <div class="ocupation-form">
        <template v-if="categories.length > 0">
            <ul class="list-group categories-list">
                <li
                    v-for="(value, index) in categories"
                    :key="value.id"
                    :data-refereindex="index"
                    @click="chooseItems($event)"
                    class="list-group-item"
                >
                    <img
                        v-if="value.id !== 6"
                        :src="`${categorypathimg}/${value.icon}.svg`"
                        :alt="value.name"
                        data-indicate="categories"
                    />
                    <p class="button-body">{{ value.name }}</p>
                </li>
            </ul>

            <button
                @click.prevent="getProfessionalCategories()"
                type="submit"
                class="btn btn-primary w-100 btn-filled-blue"
                :disabled="disabled"
            >
                Concluir
            </button>
        </template>
    </div>
</template>
<script>
//Set Use Strict
"use strict";

export default {
    emits: ["form-data"],
    name: "ProfessionalCategory",
    props: {
        categorylist: {
            type: String,
            required: true,
        },
        categorypathimg: {
            type: String,
            required: true,
        },
        renderMessage: {
            type: Function,
            required: true,
        },
    },
    data: () => {
        return {
            categories: [],
            formData: {
                professionalCategories: [],
            },
            disabled: true,
        };
    },
    created() {
        //Get Categories
        this.categories = JSON.parse(this.categorylist);
    },
    mounted() {},
    methods: {
        renderMessageMethod(message, classname = "danger") {
            this.renderMessage(message, classname);
        },
        chooseItems(element) {
            //Get Data from element
            let referElement = element.currentTarget;

            //Get Refer Index
            let referIndex = parseInt(
                referElement.getAttribute("data-refereindex")
            );

            //Add Class and Push
            if (this.formData.professionalCategories.length === 0) {
                //Push Element
                this.formData.professionalCategories.push(
                    this.categories[referIndex]
                );

                //Selected
                referElement.classList.add("selected");

                //Enabled Button
                this.disabled = false;
            } else {
                //Check Professional Categories
                let confirmPush = this.formData.professionalCategories.find(
                    (value) => value.id === this.categories[referIndex].id
                );

                if (confirmPush === undefined) {
                    //Push Element
                    this.formData.professionalCategories.push(
                        this.categories[referIndex]
                    );

                    //Selected
                    referElement.classList.add("selected");

                    //Enabled Button
                    this.disabled = false;
                } else {
                    //Get Index
                    let categoryIndex =
                        this.formData.professionalCategories.indexOf(
                            this.categories[referIndex]
                        );

                    //Remove from List
                    this.formData.professionalCategories.splice(
                        categoryIndex,
                        1
                    );

                    //Unselected
                    referElement.classList.remove("selected");
                }
            }
        },
        getProfessionalCategories() {
            //Check Professional Categories
            if (this.formData.professionalCategories.length === 0) {
                //Send Message
                this.renderMessageMethod(
                    "Por favor informar sua categoria profissional"
                );

                //Disabled Button
                this.disabled = true;

                return;
            }

            //Disabled Button
            this.disabled = true;

            return this.$emit(
                "form-data",
                this.formData.professionalCategories
            );
        },
    },
    computed: {
        professionalCategoriesComputed() {
            return this.formData;
        },
    },
    watch: {
        professionalCategoriesComputed() {},
    },
};
</script>
